import {Component, Input, AfterViewInit, OnInit, HostBinding} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'rxjs/Rx';
import {NgForm, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppConstants } from '../../../shared/constants/constants';

@Component({
  selector: 'form-label',
  templateUrl: 'label.component.html'
})
export class FormLabelComponent {
  @HostBinding('class.form-label') leftBarClass = true;
  @Input() label: string;
  @Input() id: string;
  @Input() required: boolean;
  constructor() { }

 /* isFieldRequired(id) {
    return this.requires.indexOf(id) !== -1; // check if the array contains the value
  }*/
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/form/label/label.component.ts